import React from 'react';
import { FormattedMessage } from 'react-intl';
import { LoadingSpinner } from '@doxyme/ui';
import './styles.scss';
export function BackgroundEffectsPlaceholder({ loading, }) {
    return (<div className="background-effects__preview__placeholder">
      {loading ? (<div role="progressbar" aria-busy="true">
          <LoadingSpinner />
        </div>) : (<>
          <svg className="background-effects__preview__placeholder__avatar">
            <use xlinkHref="#call-placeholder"/>
          </svg>
          <p>
            <FormattedMessage id="video-settings.camera-disabled"/>
          </p>
        </>)}
    </div>);
}
